<div class="carousel w-full">
    <div id="slide01" class="carousel-item md:h-[400px] xs:h-[122px] sm:h-[200px] relative w-full">
      <a href="/beyond" class="cursor-pointer">
        <img src="assets/images/beyond/banner-beyond.jpg">
      </a>
      <div class="">
        <a href="#slide2" class="btn btn-circle absolute left-5  top-1/2">❮</a>
        <a href="#slide000" class="btn btn-circle absolute right-5 top-1/2">❯</a>
      </div>
    </div>
    <div id="slide000" class="carousel-item h-[200px] md:h-auto relative w-full">
      <iframe class="absolute top-0 left-0 w-full h-full" width="560" height="315"
        src="https://www.youtube.com/embed/nEPae8-CblM?si=4ROsDcp01mHHtsWO" frameborder="0" allowfullscreen></iframe>
      <div class="">
        <a href="#slide01" class="btn btn-circle absolute left-5  top-1/2">❮</a>
        <a href="#slide00" class="btn btn-circle absolute right-5 top-1/2">❯</a>
      </div>
    </div>
      <div id="slide00" class="carousel-item h-[200px] md:h-auto relative w-full">
      <iframe class="absolute top-0 left-0 w-full h-full" width="560" height="315"
        src="https://www.youtube.com/embed/JNHFCk0yu8Y?si=zer3w__HMTe9OM0J" frameborder="0" allowfullscreen></iframe>
        <div class="">
          <a href="#slide5" class="btn btn-circle cursor-pointer absolute left-5  top-1/2">❮</a>
          <a href="#slide1" class="btn btn-circle absolute right-5 top-1/2">❯</a>
        </div>
      </div>
        <div id="slide1" class="carousel-item h-[200px] md:h-auto relative w-full">
      <iframe class="absolute top-0 left-0 w-full h-full" width="560" height="315"
        src="https://www.youtube.com/embed/9Dxja6qe-rc?si=B_ZFv3cscsu8sRAS" frameborder="0" allowfullscreen></iframe>
          <div class="">
            <a href="#slide00" class="btn btn-circle absolute left-5  top-1/2">❮</a>
            <a href="#slide2" class="btn btn-circle absolute right-5 top-1/2">❯</a>
          </div>
        </div>
        <div id="slide2" class="carousel-item h-[200px] md:h-auto relative w-full">
          <iframe class="absolute top-0 left-0 w-full h-full" width="560" height="315"
            src="https://www.youtube.com/embed/T-1l4Cqt1ck" frameborder="0" allowfullscreen></iframe>

          <div class="">
            <a href="#slide1" class="btn btn-circle absolute left-5  top-1/2">❮</a>
            <a href="#slide01" class="btn btn-circle absolute right-5 top-1/2">❯</a>
          </div>
        </div>
    <!-- <div id="slide0" class="carousel-item h-[200px] md:h-auto relative w-full">
    <iframe class="absolute top-0 left-0 w-full h-full" width="560" height="315"
      src="https://www.youtube.com/embed/T-1l4Cqt1ck" frameborder="0" allowfullscreen></iframe>

      <div class="">
        <a href="#slide00" class="btn btn-circle absolute left-5  top-1/2">❮</a>
        <a href="#slide1" class="btn btn-circle absolute right-5 top-1/2">❯</a>
      </div>
    </div>
    <div id="slide1" class="carousel-item h-[200px] md:h-auto relative w-full">
            <iframe class="absolute top-0 left-0 w-full h-full" width="560" height="315"
              src="https://www.youtube.com/embed/SacW_E5wgyM" frameborder="0" allowfullscreen></iframe>
      <div class="">
        <a href="#slide0" class="btn btn-circle absolute left-5  top-1/2">❮</a>
        <a href="#slide2" class="btn btn-circle absolute right-5 top-1/2">❯</a>
      </div>
    </div>
  <div id="slide2" class="carousel-item h-[200px] md:h-auto relative w-full">
          <iframe class="absolute top-0 left-0 w-full h-full" width="560" height="315"
            src="https://www.youtube.com/embed/wsot02pWFuc" frameborder="0" allowfullscreen></iframe>


    <div class="">
      <a href="#slide1" class="btn btn-circle absolute left-5  top-1/2">❮</a>
      <a href="#slide3" class="btn btn-circle absolute right-5 top-1/2">❯</a>
    </div>
  </div>
  <div id="slide3" class="carousel-item h-[200px] md:h-auto relative w-full">

    <a href="/events/e20a962b-7627-4cdb-bee2-db6d2a2280b4">
      <img src="assets/images/banner/banner-ai-wave.jpg" class="w-full object-cover object-left md:object-center" />
    </a>
    <div class="">
      <a href="#slide2" class="btn btn-circle absolute left-5  top-1/2">❮</a>
      <a href="#slide4" class="btn btn-circle absolute right-5 top-1/2">❯</a>
    </div>
  </div>

  <div id="slide4" class="carousel-item h-[200px] md:h-auto relative w-full">
          <a href="/events/157fe47c-dc01-4114-840a-7abf9c455e66">
            <img src="assets/images/banner/banner-singularity.jpg" class="w-full object-cover object-left md:object-center" />
          </a>

    <div class="">
      <a href="#slide3" class="btn btn-circle absolute left-5  top-1/2">❮</a>
      <a href="#slide5" class="btn btn-circle absolute right-5 top-1/2">❯</a>
    </div>
  </div>-->
  <div id="slide5" class="carousel-item h-[200px] md:h-auto relative w-full">
    <img src="assets/images/banner/banner-1.png" class="w-full object-cover object-left md:object-center" />
    <div class="">
      <a href="#slide2" class="btn btn-circle absolute left-5  top-1/2">❮</a>
      <a href="#slide000" class="btn btn-circle absolute right-5 top-1/2">❯</a>
    </div>
  </div>
</div>
<div class="w-full px-2 bg-[#f9f9f9]">
  <div class="container mx-auto">
    <h2 class="w-full text-center pt-6 pb-4 mb-4 text-2xl"
      [ngClass]="currentTheme === 'dark' ? 'text-slate-50' : 'text-slate-600 '">
      Watch and Get Updated
    </h2>
    <div class="tabs justify-center flex flex-wrap lg:grid gap-3 group [&_div]:border [&_div]:tab">
      <div *ngFor="let city of cities" class="tab text-xs md:text-sm" [class.active]="defaultCity === city"
        (click)="getEvents(city)">
        {{ city }}
      </div>
    </div>
    <div class="w-full justify-center gap-5 md:gap-8 grid mt-5 grid-flow-col">
      <a *ngFor="let filterBtn of filterBtns" class="text-center cursor-pointer technology-wrap hidden"
        (click)="selectedFilter(filterBtn.filter);"
        [ngClass]="(activeFilter === filterBtn.filter) ? 'text-primary' : 'text-slate-400'">
        <span class="eye-icon text-3xl"><i [class]="filterBtn.icon"></i></span>
        <p class="text-xs md:text-sm">{{filterBtn.label}}</p>
      </a>
    </div>
    <div class="tab-content-wrap">
      <ng-container *ngIf="isLoading; else content">
        <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-2 md:gap-4 pt-5 pb-9 ">
          <div class="event-list cursor-pointer" *ngFor="let event of [0,1,2,3,4]">
            <div class="flex flex-col gap-2 border [&>.skeleton]:rounded-none"
              [ngClass]="currentTheme === 'dark' ? 'border-slate-600' : 'border '">
              <div class="skeleton h-[128px] lg:h-[156px] w-full"></div>
              <div class="px-2 py-2 flex flex-col gap-2">
                <div class="skeleton h-4 w-4/5"></div>
                <div class="skeleton h-4 w-2/3"></div>
                <div class="skeleton h-4 w-16"></div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #content>
        <div class="event-list-wrap">
          <div
            class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-2 md:gap-4 pt-5 pb-9 [&>div]:border"
            [ngClass]="currentTheme === 'dark' ? '[&>div]:border-slate-600' : '[&>div]:border '">
            <ng-container *ngFor="let event of eventList">
              <div *ngIf="event.status !== 'cancelled'" (click)="routClick(event.id)" class="event-list cursor-pointer relative"
                >
                <div *ngIf="!event?.isEventImgLoad">
                  <div class="skeleton h-[128px] lg:h-[156px] w-full rounded-none"></div>
                </div>
                <div [ngStyle]="{'display': event?.isEventImgLoad ? 'block' : 'none'}">
                  <img (load)="onLoad(event)" [src]="event?.banner_image" (error)="onError($event)" width="296"
                    height="156" alt="{{event?.title}}">
                </div>
                <div class="badge absolute top-2.5 right-2.5 text-[10px] uppercase rounded bg-gradient-to-r from-pink-500
                to-red-600 border-[#ff0a4c] shadow-md text-slate-50" *ngIf="event.status === 'up_coming'">Upcoming</div>
                <div
                  class="badge absolute top-2.5 right-2.5 text-[10px] uppercase rounded bg-[#d80a0a] border-[#d80a0a] shadow-md text-slate-50"
                  *ngIf="event.status === 'ongoing'"><img class="w-4 rotate" src="assets/images/live-icon.png" alt="">
                  <span class="ml-1">LIVE</span>
                </div>
                <div class="p-3">
                  <h3 class="text-base">{{event?.title}}</h3>
                  <span class="text-sm">{{event?.start_time | date:'EEE dd MMM, yyyy hh:mm a'}}</span>
                  <ng-container *ngIf="event?.speakers && event.speakers.length > 0">
                    <div class="speaker text-sm" *ngFor="let speaker of event.speakers">
                      <span class="font-semibold capitalize" *ngIf="speaker?.name">{{speaker?.name}}</span>
                      <span *ngIf="speaker?.job_title capitalize"> - {{speaker?.job_title}}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="text-center w-full mb-6">
            <button *ngIf="showLoadMore" (click)="loadMore()"
              class="bg-transparent hover:bg-lime-500 text-lime-700 font-semibold hover:text-white py-2 px-4 border border-lime-500 hover:border-transparent rounded">
              Load More
            </button>
          </div>
        </div>
        <div *ngIf="!eventList || eventList.length === 0">
          <div class="flex justify-center items-center text-slate-600 text-lg p-5 mb-10">
            <img src="assets/images/no-event.png" class="mr-4" alt="">
            No events available
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="content-wrap py-14" [ngClass]="currentTheme === 'dark' ? 'invert' : ''">
    <div class="container mx-auto p-7 bg-opacity-80"
      [ngClass]="currentTheme === 'dark' ? 'bg-slate-800 invert' : 'bg-slate-50'">
      <h2 class="w-full pb-6  text-2xl text-lime-500	">ABOUT FAYA:80</h2>
      <p class="pb-3">FAYA:80 (read FAYA port 80) is a monthly technology session hosted by FAYA Corporation, where
        technology
        enthusiasts converge to discuss and analyse the emerging trends in technology. The sessions aim to provide a
        platform for both amateurs and experts, to keep at par with the emerging tools and technologies in the IT
        industry. The objective of this endeavour is to create further tech communities which will enable peer group
        learning.
      </p>
      <p class="pb-3">It aims to inculcate a culture of community of practice for the entrepreneurs, developers and
        technology
        professionals whereby they ignite the art of knowledge gaining and knowledge sharing.
      </p>
      <p class="pb-3">Born out of a desire that technology professionals in Technopark, Kerala, should not lag behind
        when
        it comes to
        the futuristic technologies, FAYA:80 was kick-started in June, 2013 and is organized on the first Wednesday of
        every month at the Floor of Madness, FAYA in Technopark, Trivandrum.
      </p>
      <p class="pb-3">FAYA:80 celebrated its 50th edition in July, 2017 with DISRUPT KERALA 2017, a day-long tech event,
        with a lineup
        of global speakers and visionaries. DISRUPT KERALA 2017 also saw the launch of two separate ongoing chapters of
        FAYA:80 in Kochi and Kozhikode, which are conducted on the second and third Wednesdays of the month
        respectively.
      </p>
    </div>
    <div class="container mx-auto mt-10 p-7 bg-opacity-80"
      [ngClass]="currentTheme === 'dark' ? 'bg-slate-800 invert' : 'bg-slate-50'">
      <h2 class="w-full pb-6  text-2xl text-lime-500	">Who should attend?</h2>
      <ul class="list-style grid grid-cols-1 md:grid-cols-3 ps-5">
        <li>Directors, CEOs &amp; CTOs</li>
        <li>Entrepreneurs</li>
        <li>Data Scientists</li>
        <li>Machine Learning Scientists</li>
        <li>Developers</li>
        <li>Big Data Experts</li>
        <li>All genres of Technology Enthusiasts</li>
      </ul>
    </div>
  </div>
